"use client";

import { useEffect } from "react";
export default function Calendly() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <section id="calendly-widget" className="w-full bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="w-full rounded-xl shadow-md border border-border overflow-hidden bg-card">
          <div className="calendly-inline-widget" data-url="https://calendly.com/worldimmigration-ana_delgado/consulenza-online" style={{
          minWidth: "320px",
          height: "700px"
        }} />
        </div>
      </div>
    </section>;
}